import React from 'react';
import SalinityChart from '../../../../../../components/Highcharts/LineCharts/SalinityChart/SalinityChart';
import SoilTemperatureChart from '../../../../../../components/Highcharts/LineCharts/SoilTemperatureChart/SoilTemperatureChart';
import StackedSoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/StackedSoilMoistureChart/StackedSoilMoistureChart';
import useStyles from '../../../../../../components/Highcharts/styles';
import useResponsiveChartHeight from '../../../../../../hooks/useResponsiveChartHeight';
import IrrigationChart from '../../../../../../components/Highcharts/IrrigationChart/IrrigationChart';
import SoilMoistureChart from '../../../../../../components/Highcharts/LineCharts/SoilMoistureChart/SoilMoistureChart';
import RootsChart from '../../../../../../components/Highcharts/RootsChart/RootsChart';

function SoilTemperatureSalinityDashboard({
  sectorId,
  farmId,
}: {
  sectorId: string,
  farmId: string,
}) {
  const classes = useStyles();
  const {
    minionChartHeight, smallChartHeight, mediumChartHeight, largeChartHeight,
  } = useResponsiveChartHeight();

  return (
    <div className={classes.dashboardContainer}>
      <IrrigationChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={smallChartHeight}
        yAxisTitle=""
        title="Kc y mm"
      />
      <StackedSoilMoistureChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={mediumChartHeight}
        title="Humedad de suelo"
        yAxisTitle=" "
      />
      <SoilTemperatureChart
        chartView="dashboard"
        hideLegend={false}
        hideYValues={false}
        hideXValues={true}
        sectorId={sectorId}
        farmId={farmId}
        height={mediumChartHeight}
        yAxisTitle=""
        title="Temperatura de suelo"
      />
      <SalinityChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={mediumChartHeight}
        yAxisTitle=""
        title="Salinidad de suelo apilada"
      />
      <RootsChart
        chartView="dashboard"
        hideLegend={false}
        hideXValues={true}
        hideYValues={false}
        sectorId={sectorId}
        farmId={farmId}
        height={minionChartHeight}
        yAxisTitle=""
        title="Profundidad riego y raíces"
      />
      <SoilMoistureChart
        chartView="dashboard"
        hideYValues={false}
        hideXValues={false}
        hideLegend={true}
        sectorId={sectorId}
        farmId={farmId}
        height={largeChartHeight}
        title="Sumatoria humedad de suelo"
        yAxisTitle=" "
      />
    </div>
  );
}

export default SoilTemperatureSalinityDashboard;
